module.exports = __webpack_public_path__ + "static/media/sound.8412e211.mp3";